import React, { useState, useEffect } from 'react';

import { retrieveFormsWithVisitCodes } from '../../../../../services/FormService';

import { SelectableTable } from '../../../../common/table/SelectableTable';
import { SaveButton } from '../../../../common/button/save-button/SaveButton';

import './ParticipantAddForms.css';

export const ParticipantAddForms = ({
  formList = [],
  setFormList,
  showToaster,
  setSpinnerText,
  context,
  closeModal,
  studyExternalReference,
}) => {
  const [searchResults, setSearchResults] = useState([]);
  const [selectedFormMap, setSelectedFormMap] = useState({});

  const stripTableFields = ({ selected, visitCodes, ...form }) => form;

  const getSelectedFormsFromMap = (formMap) => {
    return Object.values(formMap).map(stripTableFields);
  };

  useEffect(() => {
    const fetchData = async () => {
      setSpinnerText('Retrieving Available Forms');

      const [data, error] = await retrieveFormsWithVisitCodes(context.username, studyExternalReference);

      if (data) {
        if (data.responseStatus === 'Success') {
          const initialSelectedMap = {};

          formList.forEach((form) => {
            initialSelectedMap[form.formExternalReference] = {
              ...form,
              selected: true,
            };
          });

          const updatedSearchResults = data.forms.map((form) => ({
            ...form,
            selected: Boolean(initialSelectedMap[form.formExternalReference]),
          }));

          setSelectedFormMap(initialSelectedMap);
          setSearchResults(updatedSearchResults);
        } else {
          showToaster(data);
        }
      } else {
        showToaster({
          responseStatus: 'Error',
          responseMessage: error.message,
        });
      }

      setSpinnerText(null);
    };

    fetchData();
  }, [context.username, studyExternalReference, setSpinnerText, showToaster, formList]);

  const handleSelectedFormsChange = (changedRowsFromTable) => {
    const changedRows = Array.isArray(changedRowsFromTable) ? changedRowsFromTable : [changedRowsFromTable];

    setSelectedFormMap((previousMap) => {
      const nextMap = { ...previousMap };

      changedRows.forEach((row) => {
        if (!row?.formExternalReference) return;

        if (row.selected) {
          nextMap[row.formExternalReference] = {
            ...row,
            selected: true,
          };
        } else {
          delete nextMap[row.formExternalReference];
        }
      });

      setSearchResults((previousSearchResults) =>
        previousSearchResults.map((form) => ({
          ...form,
          selected: Boolean(nextMap[form.formExternalReference]),
        }))
      );

      return nextMap;
    });
  };

  const handleUpdateClick = () => {
    const updatedForms = getSelectedFormsFromMap(selectedFormMap);

    setFormList(updatedForms);
    closeModal();
  };

  const selectedFormsForTable = searchResults.map((form) => ({
    ...form,
    selected: Boolean(selectedFormMap[form.formExternalReference]),
  }));

  return (
    <div>
      {searchResults && (
        <SelectableTable
          tableData={selectedFormsForTable}
          hiddenColumns={['formExternalReference', 'selected', 'visitCodes']}
          searchEnabled={true}
          filterEnabled={false}
          tableTitle="Available Forms"
          buttonDisabled={true}
          onSelectedFormsChange={handleSelectedFormsChange}
          selectedForms={selectedFormsForTable}
          maxRowCount={5}
        />
      )}

      <div className="participant-add-forms-button-container">
        <SaveButton
          color="#ffffff"
          textColor="#74a47f"
          border="1px solid #74a47f"
          title="Cancel"
          onClick={closeModal}
        />

        <SaveButton color="#74a47f" title="Update" onClick={handleUpdateClick} />
      </div>
    </div>
  );
};
